<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="6">
        <b-card :header="$t('Jackpot')" style="position: relative">
          <b-form
            @submit.prevent="onSubmitDetails"
            autocomplete="off"
            ref="det"
          >
            <b-form-group
              :label="$t('Active')"
              class="grouping py-2 px-3 mb-3 mt-0"
            >
              <b-form-checkbox
                v-model="details.active"
                :value="true"
                :unchecked-value="false"
                >{{ $t("Activate jackpot") }}</b-form-checkbox
              >
            </b-form-group>

            <FloatingLabel
              v-model="details.name"
              label="Name"
              autocomplete="false"
              size="sm"
            />

            <b-row>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="info.value"
                  label="Value"
                  autocomplete="false"
                  size="sm"
                  readonly
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="info.target_value"
                  label="Target Value"
                  autocomplete="false"
                  size="sm"
                  readonly
                />
              </b-col>
              <b-col cols="12" md="4">
                <FloatingLabel
                  v-model.number="info.cancel_value"
                  label="Cancel Value"
                  autocomplete="false"
                  size="sm"
                  readonly
                />
              </b-col>
            </b-row>

            <FloatingLabel
              v-model="details.description"
              label="Description"
              autocomplete="false"
              type="textarea"
              size="sm"
            />

            <div class="mb-2 position-relative">
              <div
                class="multiselect-lbl"
                v-if="
                  details.settings.tenant_ids &&
                  details.settings.tenant_ids.length
                "
              >
                {{ $t("Tenants") }}
              </div>
              <multiselect
                v-model="details.settings.tenant_ids"
                :options="tenantsList"
                placeholder="Select tenants"
                track-by="eid"
                label="brand_name"
                :multiple="true"
                :translate="false"
              ></multiselect>
            </div>
            <div class="mb-2 position-relative">
              <div
                class="multiselect-lbl"
                v-if="
                  details.settings.shopgroup_ids &&
                  details.settings.shopgroup_ids.length
                "
              >
                {{ $t("Shop Groups") }}
              </div>
              <multiselect
                v-model="details.settings.shopgroup_ids"
                :options="shopGroupsList"
                placeholder="Select shop groups"
                track-by="eid"
                label="name"
                :multiple="true"
                :translate="false"
              ></multiselect>
            </div>
            <div class="mb-2 position-relative">
              <div
                class="multiselect-lbl"
                v-if="
                  details.settings.shop_ids && details.settings.shop_ids.length
                "
              >
                {{ $t("Shops") }}
              </div>
              <multiselect
                v-model="details.settings.shop_ids"
                :options="shopsList"
                placeholder="Select shops"
                track-by="eid"
                label="name"
                :multiple="true"
                :translate="false"
              ></multiselect>
            </div>

            <b-row>
              <b-col cols="12" md="6">
                <FloatingLabel
                  v-model.number="details.settings.min_start_value"
                  label="Min Start Value"
                  autocomplete="false"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="6">
                <FloatingLabel
                  v-model.number="details.settings.max_start_value"
                  label="Max Start Value"
                  autocomplete="false"
                  size="sm"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="6">
                <FloatingLabel
                  v-model.number="details.settings.min_target_value"
                  label="Min Target Value"
                  autocomplete="false"
                  size="sm"
                />
              </b-col>
              <b-col cols="12" md="6">
                <FloatingLabel
                  v-model.number="details.settings.max_target_value"
                  label="Max Target Value"
                  autocomplete="false"
                  size="sm"
                />
              </b-col>
            </b-row>

            <FloatingLabel
              v-model="details.settings.award_message"
              label="Award Message"
              autocomplete="false"
              type="textarea"
              size="sm"
            />

            <b-row
              v-for="(value, name, index) in details.settings.products"
              :key="index"
            >
              <b-col cols="12" md="2">{{ productName(name) }} </b-col>
              <b-col cols="12" md="10"
                ><FloatingLabel
                  v-model.number="details.settings.products[name]"
                  label="Contribution Percentage"
                  autocomplete="false"
                  size="sm"
              /></b-col>
            </b-row>

            <div style="text-align: right">
              <b-button
                type="button"
                variant="danger"
                class="mr-3"
                v-if="eid"
                @click="resetJackpot"
                >{{ $t("Reset Jackpot") }}</b-button
              >
              <b-dropdown
                variant="success"
                right
                split
                :text="$t('Save')"
                @click="onSubmitDetails"
              >
                <b-dropdown-item @click="saveAsNew">{{
                  $t("Save As New")
                }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FloatingLabel from "@/components/FloatingLabel";
import { successConf, errorConf } from "@/shared/notifications";
import Multiselect from "@/components/multiselect-filters";

const defSettings = {
  products: {},
  tenant_ids: [],
  shopgroup_ids: [],
  shop_ids: [],
  min_target_value: 0,
  max_target_value: 0,
  min_start_value: 0,
  max_start_value: 0,
  award_message: "",
};

export default {
  name: "jackpot",
  props: ["selectedeid"],
  components: {
    FloatingLabel,
    Multiselect,
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
      this.newId = true;
    }

    Promise.all([
      this.$store.dispatch("cache/fetch", "tenants").catch((e) => e),
      this.$store.dispatch("cache/fetch", "shops").catch((e) => e),
      this.$store.dispatch("cache/fetch", "shopGroups").catch((e) => e),
      this.$store.dispatch("cache/fetch", "products").catch((e) => e),
    ]).finally(() => {
      const products = {};
      const settings = JSON.parse(JSON.stringify(defSettings));

      const productsList = this.$store.getters["cache/products"];
      productsList.forEach((p) => {
        products[p.eid] = 0;
      });

      settings.products = products;
      this.details.settings = settings;

      this.loadData();
    });
  },

  data: function () {
    return {
      eid: "",
      details: {
        name: "",
        description: "",
        active: false,
        settings: JSON.parse(JSON.stringify(defSettings)),
      },
      newId: false,
      info: {
        value: 0,
        target_value: 0,
        cancel_value: 0,
      },
      temp: {},
    };
  },

  computed: {
    tenantsList() {
      return this.$store.getters["cache/tenants"];
    },
    shopGroupsList() {
      return this.$store.getters["cache/shopGroups"];
    },
    shopsList() {
      return this.$store.getters["cache/shops"];
    },
    productsList() {
      return this.$store.getters["cache/products"];
    },
  },

  methods: {
    loadData() {
      if (this.eid == "") {
        // new role; nothing to load
        return;
      }
      const loadDet = this.$loading.open({
        container: this.$refs.det,
      });

      this.$store
        .dispatch("jackpot/read", this.eid)
        .then((resp) => {
          this.temp = resp.data;
          this.populateData(resp.data);
        })
        .catch((err) => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    saveAsNew() {
      this.eid = "";
      this.newId = true;
      this.onSubmitDetails();
    },
    onSubmitDetails() {
      const loadDet = this.$loading.open({
        container: this.$refs.det,
      });

      const detailsData = JSON.parse(JSON.stringify(this.details));

      const keys = ["tenant_ids", "shopgroup_ids", "shop_ids"];
      keys.forEach((key) => {
        if (detailsData.settings[key] && detailsData.settings[key].length) {
          const tmp = [];
          detailsData.settings[key].forEach((item) => {
            tmp.push(item.eid);
          });
          detailsData.settings[key] = tmp;
        }
      });

      detailsData.settings = JSON.stringify(detailsData.settings);

      let apiAction = "jackpot/update";
      if (this.newId) {
        apiAction = "jackpot/create";
      } else {
        detailsData.eid = this.eid;
      }

      this.$store
        .dispatch(apiAction, detailsData)
        .then((resp) => {
          let msg = "Jackpot updated";
          if (this.newId && resp.data.id) {
            this.updateId(resp.data.id);
            msg = "Jackpot created";
          }
          this.showSuccessNotification(msg);
        })
        .catch((err) => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    resetJackpot() {
      const loadDet = this.$loading.open({
        container: this.$refs.det,
      });

      const data = {
        eid: this.eid,
      };

      this.$store
        .dispatch("jackpot/reset", data)
        .then((resp) => {
          let msg = "Jackpot reset";
          if (resp && resp.data) {
            if (typeof resp.data.value !== "undefined")
              this.info.value = this.roundThousands(resp.data.value);
            if (typeof resp.data.target_value !== "undefined")
              this.info.target_value = this.roundThousands(
                resp.data.target_value
              );
            if (typeof resp.data.cancel_value !== "undefined")
              this.info.cancel_value = this.roundThousands(
                resp.data.cancel_value
              );
          }
          this.showSuccessNotification(msg);
          this.loadData();
        })
        .catch((err) => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";
      this.details.name = r.name;
      this.details.description = r.description;
      this.details.active = r.active;

      let settings = r.settings ? r.settings : {};

      if (typeof settings === "string") settings = JSON.parse(settings);

      const products = {};
      const iniSettings = JSON.parse(JSON.stringify(defSettings));

      const productsList = this.$store.getters["cache/products"];
      productsList.forEach((p) => {
        products[p.eid] = 0;
      });

      iniSettings.products = products;
      this.details.settings = Object.assign(iniSettings, settings);

      const keys = ["tenant_ids", "shopgroup_ids", "shop_ids"];

      keys.forEach((key) => {
        const tmp = [];
        if (this.details.settings[key].length > 0) {
          let list = [];

          switch (key) {
            case "tenant_ids":
              list = this.tenantsList;
              break;
            case "shopgroup_ids":
              list = this.shopGroupsList;
              break;
            case "shop_ids":
              list = this.shopsList;
              break;
            default:
              list = [];
          }

          list.forEach((element) => {
            for (let i = 0; i < this.details.settings[key].length; i++) {
              if (element.eid == this.details.settings[key][i]) {
                tmp.push(element);
              }
            }
          });
        }
        this.details.settings[key] = tmp;
      });

      this.info.value = this.roundThousands(r.value);
      this.info.target_value = this.roundThousands(r.target_value);
      this.info.cancel_value = this.roundThousands(r.cancel_value);
    },
    updateId(id) {
      this.eid = id;
      this.newId = false;
      this.$router.replace({ name: "Jackpot", params: { id: id } });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    },
    productName(eid) {
      const productsList = this.$store.getters["cache/products"];
      let name = eid;
      productsList.forEach((p) => {
        if (p.eid === eid) name = p.name;
      });
      return name;
    },
    roundThousands(value) {
      if (typeof value == "string") return value;
      if (!value) return "0.00";

      const decimals = 2;
      const tmp = value / 10000;

      const res = Number(
        Math.round(tmp + "e" + decimals) + "e-" + decimals
      ).toFixed(decimals);
      return res.replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
